import { ExpiredErrorTypes } from "pages/errors/expiredLink/constants";
import { ExpiredLinkErrorPage } from "pages/errors/expiredLink/index";

export const ExpiredEmailVerificationLink = () => {
    return <ExpiredLinkErrorPage type={ExpiredErrorTypes.EmailVerification} />;
};
